import { addNewBlock } from '../utils/add-new-block';
import { FixedBlockType } from '../types/block-type';
import { Comparator } from 'z3k-config';
import { comparatorTypeTranslate } from '../utils/translates';
/**
 * @function
 * Создаю описание блока для Blockly
 * @param color_of_logic_blocks - цвет блока
 * @return BlockType - тип блока
 */
function addAndBlock(color_of_logic_blocks) {
    const block = {
        message0: 'И %1 %2',
        args0: [
            {
                type: 'input_value',
                name: 'and_1',
                check: 'Boolean',
            },
            {
                type: 'input_value',
                name: 'and_2',
                check: 'Boolean',
            },
        ],
        output: 'Boolean',
        colour: color_of_logic_blocks,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.and, block);
    return FixedBlockType.and;
}
function addOrBlock(color_of_logic_blocks) {
    const block = {
        message0: 'ИЛИ %1 %2',
        args0: [
            {
                type: 'input_value',
                name: 'or_1',
                check: 'Boolean',
            },
            {
                type: 'input_value',
                name: 'or_2',
                check: 'Boolean',
            },
        ],
        output: 'Boolean',
        colour: color_of_logic_blocks,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.or, block);
    return FixedBlockType.or;
}
function addNumericComparatorBlock(color_of_logic_blocks) {
    const block = {
        message0: '%1 %2 %3',
        args0: [
            {
                type: 'input_value',
                name: 'left',
                check: 'Number',
                align: 'RIGHT',
            },
            {
                type: 'field_dropdown',
                name: 'comparator_type',
                options: [
                    [
                        comparatorTypeTranslate[Comparator.Type.LESS],
                        Comparator.Type.LESS.toString(),
                    ],
                    [
                        comparatorTypeTranslate[Comparator.Type.MORE],
                        Comparator.Type.MORE.toString(),
                    ],
                    [
                        comparatorTypeTranslate[Comparator.Type.EQUAL],
                        Comparator.Type.EQUAL.toString(),
                    ],
                    [
                        comparatorTypeTranslate[Comparator.Type.LESS_OR_EQUAL],
                        Comparator.Type.LESS_OR_EQUAL.toString(),
                    ],
                    [
                        comparatorTypeTranslate[Comparator.Type.MORE_OR_EQUAL],
                        Comparator.Type.MORE_OR_EQUAL.toString(),
                    ],
                ],
            },
            {
                type: 'field_number',
                name: 'right',
                value: 0,
                min: -50,
            },
        ],
        inputsInline: true,
        output: 'Boolean',
        colour: color_of_logic_blocks,
        tooltip: 'Это блок для сравнения значения датчика с числом',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.numeric_comparator, block);
    return FixedBlockType.numeric_comparator;
}
function addSensorComparatorBlock(color_of_logic_blocks) {
    const block = {
        message0: '%1 %2 %3',
        args0: [
            {
                type: 'input_value',
                name: 'left',
                check: 'Number',
                align: 'RIGHT',
            },
            {
                type: 'field_dropdown',
                name: 'comparator_type',
                options: [
                    [
                        comparatorTypeTranslate[Comparator.Type.LESS],
                        Comparator.Type.LESS.toString(),
                    ],
                    [
                        comparatorTypeTranslate[Comparator.Type.MORE],
                        Comparator.Type.MORE.toString(),
                    ],
                    [
                        comparatorTypeTranslate[Comparator.Type.EQUAL],
                        Comparator.Type.EQUAL.toString(),
                    ],
                    [
                        comparatorTypeTranslate[Comparator.Type.LESS_OR_EQUAL],
                        Comparator.Type.LESS_OR_EQUAL.toString(),
                    ],
                    [
                        comparatorTypeTranslate[Comparator.Type.MORE_OR_EQUAL],
                        Comparator.Type.MORE_OR_EQUAL.toString(),
                    ],
                ],
            },
            {
                type: 'input_value',
                name: 'right',
                check: 'Number',
                align: 'RIGHT',
            },
        ],
        inputsInline: true,
        output: 'Boolean',
        colour: color_of_logic_blocks,
        tooltip: 'Это блок для сравнения двух значений датчиков',
        helpUrl: 'https://zont-online.ru/demo',
    };
    addNewBlock(FixedBlockType.sensor_comparator, block);
    return FixedBlockType.sensor_comparator;
}
function addIfThenBlock(color_of_logic_blocks) {
    const block = {
        message0: 'Если %1 То %2',
        args0: [
            {
                type: 'input_value',
                name: 'comparator',
                check: 'Boolean',
            },
            {
                type: 'input_statement',
                name: 'then',
            },
        ],
        previousStatement: null,
        nextStatement: null,
        colour: color_of_logic_blocks,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.if_then, block);
    return FixedBlockType.if_then;
}
function addIfThenElseBlock(color_of_logic_blocks) {
    const block = {
        message0: 'Если %1 То %2 Иначе %3',
        args0: [
            {
                type: 'input_value',
                name: 'comparator',
                check: 'Boolean',
            },
            {
                type: 'input_statement',
                name: 'then',
            },
            {
                type: 'input_statement',
                name: 'else',
            },
        ],
        previousStatement: null,
        nextStatement: null,
        colour: color_of_logic_blocks,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.if_then_else, block);
    return FixedBlockType.if_then_else;
}
function addNotBlock(color_of_logic_blocks) {
    const block = {
        message0: 'НЕ %1',
        args0: [
            {
                type: 'input_value',
                name: 'inp',
                check: 'Boolean',
            },
        ],
        output: 'Boolean',
        colour: color_of_logic_blocks,
        tooltip: '',
        helpUrl: '',
    };
    addNewBlock(FixedBlockType.not, block);
    return FixedBlockType.not;
}
export function generateLogicBlocks(color_of_logic_blocks) {
    return [
        addAndBlock,
        addOrBlock,
        addNumericComparatorBlock,
        addSensorComparatorBlock,
        addIfThenBlock,
        addIfThenElseBlock,
        addNotBlock,
    ].map((func) => func(color_of_logic_blocks));
}
